export function getExerciseImage(path){
    return require('./exercises/'+path)
}